<template>
    <div class="user-list">
        <h2 class="text-xl flex items-center"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> Zoznam použivateľov ({{ users.totalRecords }})</h2>
    
        <div class="fixed bottom-0 right-0 pb-6 pr-6 z-max">
            <md-button :to="{name: 'users.create'}" class="md-fab md-primary">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        
        
        <div class="user-list-items">
            <div class="flex mx-6 mt-6">
                <span class="w-1/5">Meno</span>
                <span class="w-1/5">E-mail</span>
                <span class="w-1/5">Pozícia</span>
                <span class="w-1/12">Stav</span>
                <span class="w-1/5">Dátum</span>
                <span class="ml-auto mr-2">Akcia</span>
            </div>
            <UserItem v-for="user in users.data" :key="`u`+user.id" :user="user" />
        </div>
        <ul class="flex pb-6 mt-6" v-if="users.totalPages > 0">
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 text-gray-500 rounded-full mx-2 hover:bg-gray-100 cursor-pointer bg-white"
                :aria-disabled="isFirstPage"
                :disabled="isFirstPage"
                @click="() => this.jumpPage(1)"
            >
                <font-awesome icon="arrow-left"></font-awesome>
            </li>
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 rounded-full mx-2 hover:bg-gray-100 cursor-pointer"
                v-for="page in pagesNumber"
                :key="'page'+page"
                :class="{'shadow-md bg-white text-white bg-orange-500 hover:bg-orange-400': page === users.actualPage, 'text-gray-500 bg-white': page !== users.actualPage}"
                @click="() => jumpPage(page)"
            >{{ page }}</li>
            <li
                v-ripple
                class="w-10 h-10 text-center py-2 px-1 text-gray-500 rounded-full mx-2 hover:bg-gray-100 cursor-pointer bg-white"
                :aria-disabled="isLastPage"
                :disabled="isLastPage"
                @click="() => this.jumpPage(users.totalPages)"
            >
                <font-awesome icon="arrow-right"></font-awesome>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import UserItem from "./UserItem";

    export default {
        name: "UserList",
        
        components: {
            UserItem
        },
        
        data: () => ({
            offset: 4,
            page: 1,
        }),
        
        computed: {
            ...mapState({
                users: state => state.users.all,
            }),
            
            // pagination
            isFirstPage() {
                return this.users.actualPage === 1;
            },

            isLastPage() {
                return (
                        this.users.totalPages === this.page
                );
            },

            pagesNumber() {
                let from = this.users.actualPage - this.offset;
                if (from < 1) {
                    from = 1;
                }

                let to = from + this.offset * 2;
                if (to >= this.users.totalPages) {
                    to = this.users.totalPages;
                }

                let pagesArray = [];
                for (let page = from; page <= to; page++) {
                    pagesArray.push(page);
                }

                return pagesArray;
            }
        },
        
        mounted() {
            this.fetchUsers(this.page);
        },
        
        methods: {
            fetchUsers(page = 1) {
                return this.$store.dispatch("fetchUsers", {
                    limit: 10, page, paginate: true, all: true
                });
            },
            jumpPage(page) {
                this.fetchUsers(page).then(r => {
                    window.scrollTo(0, 0);
                    this.$router.push({ query: { page } });
                });
            }
        },
        
        beforeDestroy() {
            this.$store.commit("clearUsers")
        }
    }
</script>

<style lang="scss">
    .user-list-items {
        @apply mb-10;
    }
</style>